

























import { i18n } from '@tt4b/ttam-i18n';
import { trackEvent } from '@tt4b/ttam-utils';
import { computed, defineComponent, toRefs } from '@vue/composition-api';

const name = 'ttam-auto-save-exit-common-error-dialog';
export default defineComponent({
  name,
  props: {
    visible: { type: Boolean, default: false },
    lastSaveTime: { type: String, default: '' },
  },
  setup(props, { emit }) {
    const { lastSaveTime } = toRefs(props);

    const detail = computed(() => {
      if (lastSaveTime.value) {
        return lastSaveTime.value;
      }

      return i18n.t('draft_auto_save_not_yet_saved');
    });

    const handleCancel = () => {
      trackEvent('ttam_creation_draft_exit_on_error_cancel');
      emit('close');
    };

    const handleExit = () => {
      trackEvent('ttam_creation_draft_exit_on_error_exit');
      emit('exit');
      emit('close');
    };

    return {
      name,
      detail,
      handleExit,
      handleCancel,
    };
  },
});
